export const validatePortRange = (port: number) => {
	return Number.isInteger(port) && port >= 1024 && port <= 65535;
};

export const validateHttpPort = (port?: string | number | readonly string[]) => {
	const httpPortNumber = Number(port);

	if (isNaN(httpPortNumber)) {
		return false;
	}

	return httpPortNumber === 80 || validatePortRange(httpPortNumber);
};

export const validateRtspPort = (port?: string | number | readonly string[]) => {
	const rtspPortNumber = Number(port);

	if (isNaN(rtspPortNumber)) {
		return false;
	}

	return rtspPortNumber === 554 || validatePortRange(rtspPortNumber);
};

export const validateHttpsPort = (port?: string | number | readonly string[]) => {
	const httpsPortNumber = Number(port);

	if (isNaN(httpsPortNumber)) {
		return false;
	}

	return httpsPortNumber === 443 || validatePortRange(httpsPortNumber);
};
